import type { AssetLite } from "@/entities/asset";
import type { LocationSelectParentValue } from "@/modules/location/location-select-parent";

import { getDirectParentByType } from "@/entities/ancestor";
import { uniq } from "@/utilities/array";

export const shouldDisableAssetsBatchEditLocation = (assets?: AssetLite[]) => {
  if (!assets?.length || assets.length === 1) return false;

  const organizationIds = uniq(assets.map((asset) => asset.ancestors[0].id));

  if (organizationIds.length === 1) return false;

  return true;
};

export const getAssetsBatchEditLocationInitialValue = (
  assets?: AssetLite[]
): LocationSelectParentValue => {
  if (!assets?.length) return undefined;

  const parentLocations = uniq(
    assets
      .map((asset) => getDirectParentByType(asset.ancestors, "location"))
      .filter((ancestor) => !!ancestor)
  );

  if (parentLocations.length !== 1) return undefined;

  return {
    label: parentLocations[0].name,
    value: parentLocations[0].id,
  };
};
